import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
import { API_BASE_URL } from "@/config";
import { validateToken } from "@/utils/auth";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";

export default {
  name: "CompanyVerificationAndScore",
  mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
  components: {
    BreadCrumb,
    ClientLogo,
  },
  data: () => ({
    company_registration: "",
    reg1: "",
    reg2: "",
    reg3: "",
    company_name: "",
  }),

  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
  },
  watch: {
    company_registration(new_val) {
      if (new_val && new_val.length >= 12) {
        const event = {
          target: {
            value: new_val,
            selectionStart: new_val.length,
          },
          key: "",
        };
        this.validate_reg_number(event);
      }
    },
  },
  methods: {
    validate_reg_number(event) {
        let input = event.target.value.replace(/\D/g, ''), position = event.target.selectionStart;
        if (event.key === 'Backspace' && position === 0) return;

        this.reg1 = input.slice(0, 4);
        this.reg2 = input.slice(4, 10);
        this.reg3 = input.slice(10);

        this.company_registration = [this.reg1, this.reg2, this.reg3].filter(Boolean).join('/').slice(0, 14);

        this.$nextTick(() => {
            let new_position = position + (this.company_registration.length - input.length);
            event.target.selectionStart = event.target.selectionEnd = new_position;
        });
    },
    save_cipc_plus_score_info() {
      if (!this.company_registration.trim()) {
        $(".reg-message").removeClass("d-none");
        setTimeout(() => {
          $(".reg-message").addClass("d-none");
        }, 3000);
        return false;
      }
      if (!this.company_name.trim()) {
        $(".company-name-message").removeClass("d-none");
        setTimeout(() => {
          $(".company-name-message").addClass("d-none");
        }, 3000);
        return false;
      }
      const token = localStorage.getItem("token");
      const cipc_plus_score_api = `${API_BASE_URL}/verify_api/compliance_verification/cipc_plus_score/`;

      const form_data = {
        reg1: this.reg1,
        reg2: this.reg2,
        reg3: this.reg3,
        company_name: this.company_name,
        workflow_id: this.workflow_id,
        on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
      };

      fetch(cipc_plus_score_api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(form_data),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((err) => Promise.reject(err));
          }
          return response.json();
        })
        .then((data) => {
          Swal.close();
          if (data.status && data.status === "error") {
            let message = data.message || "Verification failed";
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message,
            });
          } else if (data.status && data.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Company verification and score retrieved successfully",
              timer: 2500,
              timerProgressBar: true,
              showConfirmButton: false,
            }).then(() => {
              this.completeService();
            });
          } else {
            Swal.fire({
              icon: "error",
              text: "Results not found, please contact your service provider",
            });
          }
        })
        .catch((error) => {
          Swal.close();
          let error_message = "Error verifying company";

          if (error.Error) {
            error_message = error.Error;
          } else if (error.reg3) {
            error_message = "Please enter a valid company registration number";
          } else if (error.message) {
            error_message = error.message;
          } else if (typeof error === "string") {
            error_message = error;
          }

          Swal.fire({
            icon: "error",
            title: "Error",
            text: error_message,
          });
        });

      // Show loading
      Swal.fire({
        text: "Loading ...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    },
  },

  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.get_customer_data();
  },
};
